import React from "react"
import type { DashboardStat } from "../types"
import DashboardStatCard from "./DashboardStatCard"
import "./DashboardStatsGrid.style.scss"

interface DashboardStatsGridProps {
  stats: DashboardStat[]
}

const DashboardStatsGrid = ({ stats }: DashboardStatsGridProps) => (
  <div className="dashboard-stats-grid">
    {stats.map((stat) => (
      <DashboardStatCard key={stat.title} stat={stat} />
    ))}
  </div>
)

export default DashboardStatsGrid
